import { render } from "./ComEditor.vue?vue&type=template&id=6ee28752&ts=true"
import script from "./ComEditor.vue?vue&type=script&lang=ts"
export * from "./ComEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__